import React from 'react'
import type { Icon } from 'shared/utils'

const Milk = (props: Icon) => {
    const { color = 'black', size = 24, className = 'milk' } = props
    return (
        <svg fill={color} width={size} height={size} className={className}>
            <path
                d="M13.58 11.308c-1.577 1.192-4.846-.616-4.846-.616 0-1.23 0-1.961 1.192-4.153a13.152 13.152 0 0 0 1.194-3.154h2.576c.116 1.577 1.116 2.654 1.731 4.269.615 1.615.808 3.038.808 3.038-1.039.385-1.039-.615-2.654.616m2.115-4.539c-.307-.654-.769-1.307-1.076-1.961-.231-.462-.424-1-.5-1.5.269-.193.384-.231.346-.616A.82.82 0 0 0 13.657 2h-2.654c-.346 0-.692.23-.808.654-.115.385 0 .5.308.692-.154.923-.615 1.77-1.038 2.577-.539 1.039-1.077 2.116-1.308 3.27-.192.96-.154 2-.154 2.96v9.308c.039.193.192.347.385.347h7.807c.23 0 .615-.193.615-.423V10.5c0-1.346-.576-2.577-1.115-3.73"
                fillRule="evenodd"
            />
        </svg>
    )
}

export { Milk }
